import { render, staticRenderFns } from "./AssetsLinksTypesCreateEditDialog.vue?vue&type=template&id=f5db758c&scoped=true"
import script from "./AssetsLinksTypesCreateEditDialog.vue?vue&type=script&lang=js"
export * from "./AssetsLinksTypesCreateEditDialog.vue?vue&type=script&lang=js"
import style0 from "./AssetsLinksTypesCreateEditDialog.vue?vue&type=style&index=0&id=f5db758c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db758c",
  null
  
)

export default component.exports